import { cn } from "@/lib/utils";
import { useFormPageCopy } from "@/features/i18n/formPageCopy";
import { entryScheduleLabelClassName } from "../../entries/services/entryTimingDisplay";

interface Props {
    label: string;
}

const EntryForScheduleLine = ({ label }: Props) => {
    const copy = useFormPageCopy();

    return (
        <p data-anno="schedule" className={cn("mb-2", entryScheduleLabelClassName, "text-lg sm:text-lg")} role="status">
            {copy.entryFor(label)}
        </p>
    );
};

export default EntryForScheduleLine;
